import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { QaModule } from '@sp-shared/directives/data-cy/qa.module';
import { TwoFactorLoginComponent } from './containers/two-factor-login/two-factor-login.component';
import { ErrorsModule } from '../../directives/errors/errors.module';
import { PreLoaderModule } from '../../components/pre-loader/pre-loader.module';
import { OtpInputModule } from '../otp-input/otp-input.module';

@NgModule({
  declarations: [TwoFactorLoginComponent],
  exports: [TwoFactorLoginComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatCardModule,
    MatCheckboxModule,
    TranslateModule,
    ErrorsModule,
    PreLoaderModule,
    OtpInputModule,
    QaModule,
  ],
})
export class TwoFactorLoginModule {}
